export default "__VITE_ASSET__4a56466e__"